import React from 'react';
import PropTypes from 'prop-types';
import LineItems from '../components/LineItems';
import translator from '../translations/drupalTranslator';
import {BEFORE_ARRIVAL} from '../constants/ServicesPaymentTime';

const BookingOverviewServiceContainer = ({order, className, subtotalClassName}) => {
  const isThereDiscount = !!order.bookingPrice.discount && !!order.bookingPrice.discount.amount > 0;
  const isThereVoucherDiscount = !!order.bookingPrice.voucherDiscount && !!order.bookingPrice.voucherDiscount.amount > 0;

  let originalPrice = order.bookingPrice.rentalPrice.amount;
  if (isThereDiscount) {
    originalPrice += Math.abs(order.bookingPrice.discount.amount);
  }

  const lineItems = [
    {
      name: translator.translate('Rental'),
      price: {
        amount: originalPrice,
        currencyCode: order.bookingPrice.rentalPrice.currencyCode,
      },
      unitCount: 1,
      serviceId: 0,
    },
  ].concat(isThereDiscount ? [
    {
      name: translator.translate('Discount'),
      price: {
        amount: -1 * Math.abs(order.bookingPrice.discount.amount),
        currencyCode: order.bookingPrice.discount.currencyCode,
      },
      unitCount: 1,
      serviceId: 1,
    },
  ] : [])
    .concat(isThereVoucherDiscount ? [
      {
        name: order.payment.voucher.campaignName,
        price: {
          amount: -1 * Math.abs(order.bookingPrice.voucherDiscount.amount),
          currencyCode: order.bookingPrice.voucherDiscount.currencyCode,
        },
        unitCount: 1,
        serviceId: 'novasol-voucher',
      },
    ] : [])
    .concat(order.bookingPrice.lineItems.filter(service =>
      (service.paymentTime === BEFORE_ARRIVAL || (service.type === 'NOVASOL' && service.unitCount > 0)) && service.serviceId !== '1000'))
    .map(service => ({...service}));

  const combined = {
    name: translator.translate('Tickets'),
    price: {
      amount: 0,
      currencyCode: '',
    },
    serviceId: 3,
    unitCount: 1,
  };

  const beforeArrivalServices = order.services.filter(service =>
    service.paymentTime === BEFORE_ARRIVAL &&
    service.obligatory &&
    service.unitCount === 0 &&
    service.unitPrice.amount > 0
  ).map((service) => {
    const updatedService = {...service};
    if (updatedService.price.amount < updatedService.minimumPrice.amount) {
      updatedService.price = updatedService.minimumPrice;
    }

    if (updatedService.price.amount === 0 && updatedService.unitPrice.amount > 0) {
      updatedService.price = updatedService.unitPrice;
    }

    updatedService.unitCount = 1;
    return updatedService;
  });

  // Combine tickets into one lineItem.
  let filtered = lineItems.filter((item) => {
    if (item.serviceGroup === 301) {
      combined.price.amount += parseFloat(item.price.amount);
      combined.price.currencyCode = item.price.currencyCode;
      return false;
    }
    return true;
  });

  if (combined.price.amount !== 0) {
    filtered.push(combined);
  }

  filtered = filtered.concat(beforeArrivalServices);
  let servicesPrice = 0;
  beforeArrivalServices.forEach((service) => {
    servicesPrice += service.price.amount;
  })

  let finalPrice = {
    amount: order.bookingPrice.paymentBeforeArrival.amount + servicesPrice,
    currencyCode: order.bookingPrice.paymentBeforeArrival.currencyCode,
  };

  // If item is free set it's description to free. Used at least for security package.
  lineItems.map((item) => {
    if (item.price && item.price.amount === 0) {
      item.priceDescription = translator.translate('Free'); // eslint-disable-line no-param-reassign
    }
    return item;
  });

  // Add the subtotal line to the items.
  const beforeArrivalLineItems = filtered.concat([{
    name: translator.translate('Pay before departure'),
    price: finalPrice,
    serviceId: 'beforeArrival',
    unitCount: 1,
    className: subtotalClassName,
  }]);

  return (
    <section className="booking-overview__section pay-before-items">
      <LineItems
        className={className}
        lineItems={beforeArrivalLineItems}
      />
    </section>
  );
};

BookingOverviewServiceContainer.PropTypes = {
  order:PropTypes.shape({
    bookingPrice:PropTypes.shape({
      paymentBeforeArrival:PropTypes.object.isRequired,
      discount:PropTypes.object,
      voucherDiscount:PropTypes.object,
      rentalPrice:PropTypes.object.isRequired,
      lineItems:PropTypes.array,
    }).isRequired,
  }).isRequired,
  className:PropTypes.string.isRequired,
  subtotalClassName:PropTypes.string.isRequired,
};

export default BookingOverviewServiceContainer;
